/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type CreatePluginForm = {
  /**
   * Optional description.
   */
  description?: string | undefined;
  /**
   * Display name for the plugin.
   */
  name: string;
  /**
   * Optional URL-safe identifier. Auto-generated from name if omitted.
   */
  slug?: string | undefined;
};

/** @internal */
export type CreatePluginForm$Outbound = {
  description?: string | undefined;
  name: string;
  slug?: string | undefined;
};

/** @internal */
export const CreatePluginForm$outboundSchema: z.ZodMiniType<
  CreatePluginForm$Outbound,
  CreatePluginForm
> = z.object({
  description: z.optional(z.string()),
  name: z.string(),
  slug: z.optional(z.string()),
});

export function createPluginFormToJSON(
  createPluginForm: CreatePluginForm,
): string {
  return JSON.stringify(
    CreatePluginForm$outboundSchema.parse(createPluginForm),
  );
}
